import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { QuickbooksSetting } from './QuickbooksSetting'
import { QuickbooksSettingMapper } from './QuickbooksSettingMapper'

export class QuickbooksSettingCollection {
  protected collection: string = 'quickbooksSetting'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchQuickbooksSetting(id: string): { data: QuickbooksSetting | null } {
    const query = this.initQuery()
    return query.watch(id)
  }

  getQuickbooksSetting(id: string): Promise<QuickbooksSetting | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  async getQuickbooksSettingByRestaurantCompanyId(restaurantCompanyId: string): Promise<QuickbooksSetting | null> {
    const query = this.initQuery()
    query.setQuery(this.getQuickbooksSettingsByRestaurantCompanyIdQuery(query, restaurantCompanyId).limit(1))
    const quickbooksSettings = await query.list()
    return quickbooksSettings.length ? quickbooksSettings[0] : null
  }

  save(quickbooksSetting: QuickbooksSetting): Promise<QuickbooksSetting> {
    const query = this.initQuery()
    return query.save(quickbooksSetting)
  }

  delete(quickbooksSetting: QuickbooksSetting) {
    const query = this.initQuery();
    return query.delete(quickbooksSetting)
  }

  protected initQuery(): FirestoreQuery<QuickbooksSetting> {
    const query = new FirestoreQuery<QuickbooksSetting>(this.db, new QuickbooksSettingMapper())
    query.collection(this.collection)

    return query
  }

  protected getQuickbooksSettingsByRestaurantCompanyIdQuery(query: FirestoreQuery<QuickbooksSetting>, restaurantCompanyId: string) {
    return this.getQuickbooksSettingsByFieldValue(query, 'restaurantCompanyId', restaurantCompanyId)
  }

  protected getQuickbooksSettingsByFieldValue(query: FirestoreQuery<QuickbooksSetting>, field: string, value: any) {
    return query.collection(this.collection).where(field, '==', value)
  }
}
